import { render, staticRenderFns } from "./newLocationAddress.vue?vue&type=template&id=5245f1f6&scoped=true"
import script from "./newLocationAddress.vue?vue&type=script&lang=js"
export * from "./newLocationAddress.vue?vue&type=script&lang=js"
import style0 from "./newLocationAddress.vue?vue&type=style&index=0&id=5245f1f6&prod&lang=scss&scoped=true"
import style1 from "./newLocationAddress.vue?vue&type=style&index=1&id=5245f1f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5245f1f6",
  null
  
)

export default component.exports